import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { formatearPesoMXN } from "../../../utilis/formatter";

const BankTransferConfirmationModal = ({ data }: any) => {

  return (
    <>
      <DialogContent>
        {/* Success Icon */}
        <Box textAlign="center" mt={4}>
          <CheckCircleIcon
            sx={{
              fontSize: 70,
              color: "#22c55e",
              background: "#dcfce7",
              borderRadius: "50%",
              p: 1,
            }}
          />
          <Typography variant="h4" fontWeight={700} mt={2}>
            Pago
          </Typography>
          <Typography variant="body2" color="text.secondary" mt={1}>
            Transaction ID: {data?.move_id}
          </Typography>

          {/* <Chip
            label="CONFIRMED"
            sx={{
              mt: 2,
              backgroundColor: "#dcfce7",
              color: "#15803d",
              fontWeight: 600,
            }}
          /> */}
        </Box>

        {/* Payer Info */}
        <Box
          mt={4}
          p={3}
          sx={{
            backgroundColor: "#f3f4f6",
            borderRadius: 3,
          }}
        >
          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography variant="caption" color="text.secondary">
                Cliente
              </Typography>
              <Typography fontWeight={600}>
                {data?.full_name}
              </Typography>
            </Box>

            <Box textAlign="right">
              <Typography variant="caption" color="text.secondary">
                Pago
              </Typography>
              <Typography fontWeight={700} fontSize={22} color="primary">
                {formatearPesoMXN(data?.amount)}
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Typography variant="caption" color="text.secondary">
       
          </Typography>
          <Typography>Pago por transferencia</Typography>
        </Box>

        {/* Order Summary */}
        <Typography variant="h6" fontWeight={600} mt={4}>
          Orden
        </Typography>

        <Box
          mt={2}
          p={2}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
          }}
        >
          {data?.metadata?.items.map((item: any) => {
            return (
              <Box display="flex" justifyContent="space-between">
                <Box>
                  <Typography fontWeight={600}>{item?.name}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {item?.sku}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" mt={1}>
                    {"Cantidad: " +
                      item?.quantity +
                      " x " +
                      formatearPesoMXN(item?.price)}
                  </Typography>
                </Box>

                <Typography fontWeight={600}>
                  {formatearPesoMXN(item?.subtotal)}
                </Typography>
              </Box>
            );
          })}
        </Box>

        {/* Totals */}
        <Box mt={3}>
          <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography color="text.secondary">Subtotal</Typography>
            <Typography> {formatearPesoMXN(data?.amount)}</Typography>
          </Box>

          {/* <Box display="flex" justifyContent="space-between" mb={1}>
            <Typography color="text.secondary">VAT (0%)</Typography>
            <Typography>$0.00</Typography>
          </Box> */}

          <Divider sx={{ my: 2 }} />

          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6" fontWeight={700}>
              Total
            </Typography>
            <Typography variant="h5" fontWeight={700} color="primary">
              {formatearPesoMXN(data?.amount)}
            </Typography>
          </Box>
        </Box>

        {/* Buttons */}
        <Box mt={4} display="flex" justifyContent="space-between" gap={2}>
          {/* <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            sx={{
              flex: 1,
              borderRadius: 3,
              textTransform: "none",
              py: 1.5,
            }}
          >
            Receipt
          </Button> */}

          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              flex: 2,
              borderRadius: 3,
              textTransform: "none",
              py: 1.5,
              fontWeight: 600,
            }}
          >
            Regresar
          </Button>
        </Box>
      </DialogContent>
    </>
  );
};

export default BankTransferConfirmationModal;
